import { __extends } from "tslib";
import { IgrStrategyBasedIndicator } from "./igr-strategy-based-indicator";
import { MassIndexIndicator } from "./MassIndexIndicator";
/**
 * Represents a IgxDataChartComponent Mass Index indicator series.
 * Default required members: High, Low
*
* Represents a Ignite UIDataChart Mass Index indicator series.
*
* Example:
*
* ```ts
*  <IgrDataChart
*     dataSource={this.state.dataSource} >
*
*     <IgrCategoryXAxis name="xAxis" />
*     <IgrNumericYAxis name="yAxis" />
*
*     <IgrMassIndexIndicator
* 	name="series1"
* 	volumeMemberPath="Volume"
* 	highMemberPath="High"
* 	lowMemberPath="Low"/>
*  </IgrDataChart>
* ```
*
* ```ts
* this.series = new IgrMassIndexIndicator ({ name: "Series1" });
* this.series.dataSource = this.data;
* this.series.xAxis = this.categoryXAxis;
* this.series.yAxis = this.numericYAxis;
* this.series.xAxisName = "categoryXAxis";
* this.series.yAxisName = "numericYAxis";
* this.series.volumeMemberPath="Volume" ;
* this.series.highMemberPath= "High" ;
* this.series.lowMemberPath="Low" ;
* ```
*/
var IgrMassIndexIndicator = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(IgrMassIndexIndicator, _super);
    function IgrMassIndexIndicator(props) {
        return _super.call(this, props) || this;
    }
    IgrMassIndexIndicator.prototype.createImplementation = function () {
        return new MassIndexIndicator();
    };
    Object.defineProperty(IgrMassIndexIndicator.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: false,
        configurable: true
    });
    return IgrMassIndexIndicator;
}(IgrStrategyBasedIndicator));
export { IgrMassIndexIndicator };
